exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_object-pie.js
// module id = 24
// module chunks = 0